import { useTranslation } from 'next-i18next';
import { useAlertDialog } from '../../hooks';
export function useInvalidAccessErrorDialog() {
  const {
    t
  } = useTranslation(['common']);
  const alertDialog = useAlertDialog();
  async function open() {
    return await alertDialog.open({
      title: t('googleClassroom.invalidAccessErrorDialog.title'),
      content: t('googleClassroom.invalidAccessErrorDialog.content')
    });
  }
  return {
    open,
    didOpen: alertDialog.didOpen
  };
}